
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.667 2.667v26.666H5.333V9.778l7.112-7.111h14.222zM24 5.334H13.334v5.333H8v16h16V5.333zm-2.667 16V24H10.667v-2.667h10.666zm0-5.334v2.667H10.667V16h10.666z","fill":"#DB000D","fill-rule":"evenodd"}})])
          )
        }
      }
    